import React from 'react';
import './Navbar.scss';
import { Link } from 'react-router-dom';
import {IoIosArrowDown} from 'react-icons/io';
import { listitems, menu1, menu2, menu3, menu4, menu5, menu6 } from './data';
const Navbar=(props)=>{
    return(
        <div className="navbar">
            <ul>
                <div className="menulink">

            
                <Link to="/Products" id="menu" className="megamenulink" >
                    Products
                    <IoIosArrowDown className="arrow" />
                    <div className="megamenu">
                        <ul className="mainul">
                            {menu1.map((item) =>{
                                return(
                                    <li>
                                         <Link to={item.to}>

                                        <div>
                                            <div className="circle">
                                                <img src={item.icon} />
                                            </div>
                                        </div>
                                        <div className="info">
                                            <h3>{item.title}</h3>
                                            <p>{item.desc}</p>
                                        </div>
                                         </Link>
                                    </li>
                                )
                            })}
                        </ul>
                        <ul className=" mainul secondul">
                            {menu2.map((item) =>{
                                return(
                                    <li>
                                         <Link to={item.to}>

                                        <div>
                                            <div className="circle">
                                                <img src={item.icon} />
                                            </div>
                                        </div>
                                        <div className="info">
                                            <h3>{item.title}</h3>
                                            <p>{item.desc}</p>
                                        </div>
                                         </Link>
                                    </li>
                                )
                            })}
                        </ul>
                        <ul className="lastul">
                            {listitems.map((item) =>{
                                return(
                                    <li>
                                        <img src={item.item} />
                                        <p>{item.title}</p>
                                    </li>
                                )
                            })}
                        </ul>
                    </div>
                    </Link>
                    </div>
                <Link to="/Pricing">
                    Pricing
                    
                </Link>
                <Link to="/Enterprise">
                    Enterprise
                </Link>
                <Link to="/blog">
                    Blog
                </Link>
                <div className="menulink">
                <Link to="/about-us" id="menu2" className="megamenulink megamenulink2" >
                 About
                 <IoIosArrowDown className="arrow" />
                 <div className="megamenu megamenu2">
                        <ul className="mainul">
                            {menu3.map((item) =>{
                                return(
                                    <li>
                                        <Link to={item.to}>
                                        <div>
                                            <div className="circle">
                                                <img src={item.icon} />
                                            </div>
                                        </div>
                                        <div className="info">
                                            <h3>{item.title}</h3>
                                            <p>{item.desc}</p>
                                        </div>
                                    </Link>
                                    </li>
                                )
                            })}
                        </ul>
                        <ul className=" mainul secondul">
                            {menu4.map((item) =>{
                                return(
                                    <li>
                                        <Link to={item.to}>
                                        <div>
                                            <div className="circle">
                                                <img src={item.icon} />
                                            </div>
                                        </div>
                                        <div className="info">
                                            <h3>{item.title}</h3>
                                            <p>{item.desc}</p>
                                        </div>
                                    </Link>
                                    </li>
                                )
                            })}
                        </ul>
                   
                    </div>
                </Link>
                </div>
                <div className="menulink">
                <Link to="/apps"  id="menu3" className="megamenulink megamenulink2" >
                Apps
                <IoIosArrowDown className="arrow" />
                <div className="megamenu megamenu2 megamenu3">
                        <ul className="mainul">
                            {menu5.map((item) =>{
                                return(
                                    <li>
                                        <Link to={item.to}>
                                        <div>
                                            <div className="circle">
                                                <img src={item.icon} />
                                            </div>
                                        </div>
                                        <div className="info">
                                            <h3>{item.title}</h3>
                                            <p>{item.desc}</p>
                                        </div>
                                    </Link>
                                    </li>
                                )
                            })}
                        </ul>
                        <ul className=" mainul secondul">
                            
                            {menu6.map((item) =>{
                                return(
                                    <li>
                                        <Link to={item.to}>
                                        <div>
                                            <div className="circle">
                                                <img src={item.icon} />
                                            </div>
                                        </div>
                                        <div className="info">
                                            <h3>{item.title}</h3>
                                            <p>{item.desc}</p>
                                        </div>
                                    </Link>
                                    </li>
                                )
                            })}
                        </ul>
                   
                    </div>
                </Link>
                </div>
                <Link to="/contact">
               Contact
                </Link>
               
            </ul>
        </div>
    )
};
export default Navbar ;